import { Info } from 'lucide-react'
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from '@/common/ui/tooltip'

export function RtpPresetInfoTooltip() {
	return (
		<TooltipProvider>
			<Tooltip>
				<TooltipTrigger asChild>
					<button
						type="button"
						className="inline-flex items-center justify-center rounded-full hover:bg-muted"
					>
						<Info className="h-4 w-4 text-muted-foreground" />
					</button>
				</TooltipTrigger>
				<TooltipContent
					className="max-w-sm border bg-popover p-4 text-popover-foreground shadow-md"
					side="right"
				>
					<div className="space-y-3 text-sm">
						<div>
							<p className="mb-2 font-semibold">วิธีการใช้งาน Preset:</p>
							<p className="text-foreground">
								จำนวนเทิร์นโอเวอร์คือจำนวนเทิร์นที่ผู้เล่นต้องทำเพื่อให้ Preset
								นี้เริ่มใช้งาน
							</p>
						</div>

						<div className="space-y-2">
							<p className="font-medium">ตัวอย่างการตั้งค่า:</p>
							<ul className="space-y-2 text-sm">
								<li>
									• ตั้ง <strong>0</strong> → ใช้ Preset ตั้งแต่เริ่มเลย
								</li>
								<li>
									• ตั้ง <strong>500</strong> → เมื่อผู้เล่นทำเทิร์นถึง 500
									Preset จะเริ่มทำงาน
								</li>
								<li>
									• ตั้ง <strong>1,000</strong> → เมื่อผู้เล่นทำเทิร์นถึง 1,000
									Preset จะเปลี่ยนเป็นตัวใหม่
								</li>
							</ul>
						</div>
					</div>
				</TooltipContent>
			</Tooltip>
		</TooltipProvider>
	)
}
